import { useMemo } from "preact/hooks"
import {
    buildOptionsFromSkus,
    createVariantsFromSkus,
    getOptionIndexes,
    mergeProductSkus
} from "../helpers/productVariants"
import { useShopifyVariants } from "./useShopifyVariants"

export const useProductVariantsData = (product) => {
    const { shopifySkus, shopifyImages } = useShopifyVariants(product)

    const mergedSkus = useMemo(() => {
        return mergeProductSkus(product?.skus, shopifySkus)
    }, [product?.productId, product?.skus, shopifySkus])

    const { optionNames, optionsWithValues } = useMemo(() => {
        return buildOptionsFromSkus(mergedSkus)
    }, [mergedSkus])

    const variants = useMemo(() => {
        return createVariantsFromSkus(mergedSkus, optionNames)
    }, [mergedSkus, optionNames])

    const optionIndexes = useMemo(() => {
        return getOptionIndexes(optionNames)
    }, [optionNames])

    const hasQuickBuy = optionNames.some((option) => ["Size", "Color"].includes(option))
    const productOptions = optionsWithValues.Size || []
    const swatches = optionIndexes.colorKey ? optionsWithValues[optionIndexes.colorKey] : []

    return {
        shopifySkus,
        mergedSkus,
        optionNames,
        optionsWithValues,
        optionIndexes,
        variants,
        hasQuickBuy,
        productOptions,
        swatches,
        shopifyImages
    }
}
